/** Chakra style props for the dark-themed wallet dialog content (spread onto ModalContent). */
const walletDialogPaperSx = {
    background: "rgba(30, 30, 30, 0.95)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "xl"
};

/** Chakra style props for dark-themed inputs in wallet dialogs (spread onto Input). */
const walletTextFieldSx = {
    color: "rgba(255, 255, 255, 0.9)",
    borderColor: "rgba(255, 255, 255, 0.2)",
    _hover: { borderColor: "rgba(255, 255, 255, 0.3)" },
    _focus: { borderColor: "#17dcb8", boxShadow: "none" }
};

/** Chakra style props for cancel buttons in wallet dialogs (spread onto Button). */
const walletCancelButtonSx = {
    color: "rgba(255, 255, 255, 0.8)",
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    _hover: { background: "rgba(255, 255, 255, 0.1)", border: "1px solid rgba(255, 255, 255, 0.15)" }
};

export { walletDialogPaperSx, walletTextFieldSx, walletCancelButtonSx };
